import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentService, FakeData, Gha } from '../../core';

@Component({
  selector: 'mart-gha-contact-popup',
  templateUrl: './gha-contact-popup.component.html',
  styleUrl: './gha-contact-popup.component.scss',
  standalone: false,
})
export class GhaContactPopupComponent implements OnInit {
  @Input() row: FakeData;
  @Output() onDownload = new EventEmitter();

  gha: Gha;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly attachmentService: AttachmentService,
  ) {}

  ngOnInit(): void {
    this.gha = this.row?.gha;
  }

  getAgent() {
    return this.gha.name != null ? this.gha.name : '-';
  }

  getAddress() {
    return this.gha.address != null ? this.gha.address : '-';
  }

  getIconPath(fileName: string): string {
    return this.attachmentService.getIconPath(fileName);
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text);
  }

  downloadGHADownload(attachmentId: number) {
    this.onDownload.emit(attachmentId);
  }

  closeModal() {
    this.activeModal.dismiss();
  }
  getFileName(fileName: string): string {
    return fileName.substring(0, fileName.lastIndexOf('.'));
  }
}
